import { getOwner } from '@ember/application';
import { get } from '@ember/object';
import require from 'require';
import normalizeModelName from './normalize-model-name';
var _modelForMixin;
if (true /* HAS_MODEL_PACKAGE */) {
  var _found;
  _modelForMixin = function () {
    if (!_found) {
      _found = require('@ember-data/model/-private')._modelForMixin;
    }
    return _found(...arguments);
  };
}
export class DSModelSchemaDefinitionService {
  constructor(store) {
    this.store = store;
    this._modelFactoryCache = Object.create(null);
    this._relationshipsDefCache = Object.create(null);
    this._attributesDefCache = Object.create(null);
  }

  // Following the existing RD implementation
  attributesDefinitionFor(identifier) {
    var modelName, attributes;
    if (typeof identifier === 'string') {
      modelName = identifier;
    } else {
      modelName = identifier.type;
    }
    attributes = this._attributesDefCache[modelName];
    if (attributes === undefined) {
      var modelClass = this.store.modelFor(modelName);
      var attributeMap = get(modelClass, 'attributes');
      attributes = Object.create(null);
      attributeMap.forEach((meta, name) => attributes[name] = meta);
      this._attributesDefCache[modelName] = attributes;
    }
    return attributes;
  }

  // Following the existing RD implementation
  relationshipsDefinitionFor(identifier) {
    var modelName, relationships;
    if (typeof identifier === 'string') {
      modelName = identifier;
    } else {
      modelName = identifier.type;
    }
    relationships = this._relationshipsDefCache[modelName];
    if (relationships === undefined) {
      var modelClass = this.store.modelFor(modelName);
      relationships = get(modelClass, 'relationshipsObject') || null;
      this._relationshipsDefCache[modelName] = relationships;
    }
    return relationships;
  }
  doesTypeExist(modelName) {
    var normalizedModelName = normalizeModelName(modelName);
    var factory = getModelFactory(this.store, this._modelFactoryCache, normalizedModelName);
    return factory !== null;
  }
}

/**
 *
 * @param store
 * @param cache modelFactoryCache
 * @param normalizedModelName already normalized modelName
 * @return {*}
 */
export function getModelFactory(store, cache, normalizedModelName) {
  var factory = cache[normalizedModelName];
  if (!factory) {
    factory = _lookupModelFactory(store, normalizedModelName);
    if (!factory && true /* HAS_MODEL_PACKAGE */) {
      //Support looking up mixins as base types for polymorphic relationships
      factory = _modelForMixin(store, normalizedModelName);
    }
    if (!factory) {
      // we don't cache misses in case someone wants to register a missing model
      return null;
    }
    var klass = factory.class;
    if (klass.isModel) {
      var hasOwnModelNameSet = klass.modelName && Object.prototype.hasOwnProperty.call(klass, 'modelName');
      if (!hasOwnModelNameSet) {
        Object.defineProperty(klass, 'modelName', {
          value: normalizedModelName
        });
      }
    }
    cache[normalizedModelName] = factory;
  }
  return factory;
}
export function _lookupModelFactory(store, normalizedModelName) {
  var owner = getOwner(store);
  return owner.factoryFor(`model:${normalizedModelName}`);
}